'use client';

import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { CSSProperties, styled } from '@linaria/react';
import { LiTvEmbedPlayer } from 'fe-common-library-v2/components';
import { memo } from 'react';
import Skeletion from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const DEFAULT_SOURCE_CODE = 'Y3ky';
const LITV_CONTAINER_HEIGHT = 515;

const View = styled(LiTvEmbedPlayer)`
  margin: 40px 0;
  width: 100%;
  height: ${LITV_CONTAINER_HEIGHT}px;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    margin: 0;
    height: auto;
  }

  @media screen and (max-width: ${SCREEN_SIZE.MOBILE - 1}px) {
    margin: 0;
    height: auto;
  }
`;

const LiTV = ({
  sourceCode = DEFAULT_SOURCE_CODE,
  containerStyle = {}
}: {
  sourceCode?: string;
  containerStyle?: CSSProperties;
}) => {
  return (
    <section id='LiTV'>
      <View sourceCode={sourceCode} style={containerStyle}>
        <Skeletion height={LITV_CONTAINER_HEIGHT} />
      </View>
    </section>
  );
};

export default memo(LiTV);
